import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Property } from '../_models/property';
import { FinancialService } from '../_services/financial.service';
import { PropertyService } from '../_services/property.service';
import { environment } from '../../environments/environment';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import {
  faPlusCircle,
  faPaperPlane,
  faTimesCircle,
  faHashtag,
  faBed,
  faSearch,
  faCog,
  faBuilding,
  faHouse,
  faCar,
  faCircleArrowRight,
  faPenToSquare,
  faCircleArrowLeft,
  faDownload,
  faPrint,
  faEye,
  faSort,
  faCirclePlus
} from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { Location, PercentPipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { Compliance } from '../_models/compliance';
import moment from 'moment';
import Chart from 'chart.js/auto';
import $ from 'jquery';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-compliance',
  templateUrl: './compliance.component.html',
  styleUrls: ['./compliance.component.css'],
  standalone: false
})
export class ComplianceComponent {
  action: any;
  searchProperty: any;

  pageLoading = false;
  generatingfile = false;

  complianceDataForm!: FormGroup;
  property!: Property;
  properties: Property[] = [];
  complianceList: Compliance[] = [];

  sortOrder: 'asc' | 'desc' = 'asc';
  msortOrder: 'desc' | 'asc' = 'desc';
  psortOrder: 'desc' | 'asc' = 'desc';

  faPlusCircle = faPlusCircle;
  faHashTag = faHashtag;
  faBed = faBed;
  faBuilding = faBuilding;
  faHouse = faHouse;
  faCar = faCar;
  faSort = faSort;
  faDownload = faDownload;
  faPrint = faPrint;
  faSearch = faSearch;
  faPaperPlane = faPaperPlane;
  faTimesCircle = faTimesCircle;
  faCircleArrowRight = faCircleArrowRight;
  faCog = faCog;
  faEye = faEye;
  faPenToSquare = faPenToSquare;
  faCircleArrowLeft = faCircleArrowLeft;
  faCirclePlus = faCirclePlus;

  compliancedata!: any;

  summaryStats = {
    totalUnits: 0,
    compliantUnits: 0,
    nonCompliantUnits: 0,
    compliancePercentage: 0,
    currentPeriodCompliant: 0,
    outstandingValue: 0
  };

  monthlyBreakdown: { label: string; units: number; percentage: number; outstanding: number; }[] = [];

  constructor(
    private route: ActivatedRoute,
    private percentPipe: PercentPipe,
    private _location: Location,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private financialService: FinancialService,
    private router: Router,
    private propertyService: PropertyService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => this.action = params['action']);

    this.complianceDataForm = this.formBuilder.group({
      property_id: [{ value: '', disabled: true }, Validators.required],
      property_name: [{ value: '', disabled: true }, Validators.required],
      number_units: [{ value: '', disabled: true }, Validators.required],
      property_type: [{ value: '', disabled: true }, Validators.required],
      percentageytd: ['', Validators.required],
      currentnumbercompliant: ['', Validators.required],
      compliantnumberytd: ['', Validators.required],
    });

    this.propertyService.getMyPropertyAssociations().subscribe({
      next: (associations: any[]) => {
        this.properties = (associations || []).map((assoc) => ({
          id: assoc.propertyId,
          name: assoc.propertyDetails.name,
          property_type: assoc.propertyDetails.property_type,
          address: assoc.propertyDetails.address,
          obligationCategoryId: assoc.propertyDetails.obligationCategoryId ?? 0,
          premises: []
        })) || [];

        if (!environment.production) {
          console.log('Property data: Compliance:: ', this.properties);
        }

        if (this.action !== 'create') {
          if (this.properties.length === 0) {
            console.log('No property found');
          } else if (this.properties.length === 1) {
            if (!environment.production) {
              console.log('1 Property found', this.properties);
            }
            this.propertyService.setProperty(this.properties[0]);
            this.viewPropertyCompliance();
          } else {
            this.action = 'index';
          }
        }
      },
      error: (error) => {
        if (!environment.production) {
          console.log('Fail to load property data: Compliance', error);
        }
      }
    });
  }

  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 16,
          color: '#1f2937'
        }
      }
    }
  };

  public pieChartLabels = ['Compliant', 'Non-compliant'];
  public pieChartDatasets = [{
    data: [0, 0],
    backgroundColor: ['#1f9d61', '#e74c3c'],
    hoverOffset: 6
  }];
  public pieChartLegend = true;
  public pieChartPlugins = [];

  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['0 months', '1-2 months', '3-6 months', '7+ months'],
    datasets: [{
      data: [0, 0, 0, 0],
      label: 'Units by outstanding period',
      backgroundColor: ['#1f9d61', '#2c7be5', '#f39c12', '#e74c3c'],
      borderRadius: 8
    }]
  };

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: { color: '#1f2937' }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(148, 163, 184, 0.15)' },
        ticks: { color: '#475569' }
      },
      x: {
        grid: { display: false },
        ticks: { color: '#475569' }
      }
    }
  };

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [{
      data: [0, 0, 0, 0, 0, 0],
      label: 'Compliance %',
      fill: true,
      tension: 0.35,
      borderColor: '#2c7be5',
      backgroundColor: 'rgba(44, 123, 229, 0.12)',
      borderWidth: 3,
      pointRadius: 4,
      pointHoverRadius: 5
    }]
  };

  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: { color: '#1f2937' }
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: {
          callback: (value) => `${value}%`,
          color: '#475569'
        },
        grid: { color: 'rgba(148, 163, 184, 0.15)' }
      },
      x: {
        grid: { display: false },
        ticks: { color: '#475569' }
      }
    }
  };
  public lineChartLegend = true;

  getOutstandingMonths(premise: any): number {
    const rawValue = premise?.totalMonthsOutstanding ?? premise?.totalmonthsoutstanding ?? 0;
    const value = Number(rawValue);
    return Number.isFinite(value) ? value : 0;
  }

  getOutstandingAmount(premise: any): number {
    const rawValue = premise?.totalmaintenanceoutstanding ?? premise?.totalMaintenanceOutstanding ?? 0;
    const value = Number(rawValue);
    return Number.isFinite(value) ? value : 0;
  }

  getDisplayDate(premise: any): string {
    const value = premise?.lastmaintenancepayment?.period ?? premise?.lastMaintenancePayment?.period;
    return value ? new Date(value).toLocaleDateString('en-AU', { month: 'short', year: 'numeric' }) : 'No data';
  }

  private updateComplianceSummaryAndCharts(): void {
    const unitCount = Math.max(this.property?.premises?.length ?? 0, this.complianceList.length || 0);
    const compliantUnits = this.complianceList.filter((premise) => this.getOutstandingMonths(premise) <= 0 || this.getOutstandingAmount(premise) <= 0).length;
    const nonCompliantUnits = Math.max(unitCount - compliantUnits, 0);
    const compliancePercentage = unitCount > 0 ? (compliantUnits / unitCount) * 100 : 0;
    const currentPeriodCompliant = this.complianceList.filter((premise) => this.getOutstandingMonths(premise) <= 1).length;
    const outstandingGroups = {
      '0 months': 0,
      '1-2 months': 0,
      '3-6 months': 0,
      '7+ months': 0
    };

    this.complianceList.forEach((premise) => {
      const outstandingMonths = this.getOutstandingMonths(premise);
      if (outstandingMonths <= 0) {
        outstandingGroups['0 months'] += 1;
      } else if (outstandingMonths <= 2) {
        outstandingGroups['1-2 months'] += 1;
      } else if (outstandingMonths <= 6) {
        outstandingGroups['3-6 months'] += 1;
      } else {
        outstandingGroups['7+ months'] += 1;
      }
    });

    const generatedTrend = [
      Math.max(0, compliancePercentage - 18),
      Math.max(0, compliancePercentage - 9),
      Math.max(0, compliancePercentage - 4),
      compliancePercentage,
      Math.min(100, compliancePercentage + 6),
      Math.min(100, compliancePercentage + 4)
    ];

    const monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
    this.monthlyBreakdown = monthLabels.map((label, index) => {
      const percentage = Number(Math.max(0, Math.min(100, generatedTrend[index] || 0)).toFixed(1));
      const units = Math.round((unitCount * percentage) / 100);

      return {
        label,
        units,
        percentage,
        outstanding: Math.max(unitCount - units, 0)
      };
    });

    this.summaryStats = {
      totalUnits: unitCount,
      compliantUnits,
      nonCompliantUnits,
      compliancePercentage,
      currentPeriodCompliant,
      outstandingValue: this.complianceList.reduce((sum, premise) => sum + this.getOutstandingAmount(premise), 0)
    };

    this.complianceDataForm.patchValue({
      property_id: this.property?.id ?? '',
      property_name: this.property?.name ?? '',
      number_units: unitCount,
      property_type: this.property?.property_type ?? '',
      percentageytd: this.percentPipe.transform(compliancePercentage / 100, '1.0-1') ?? '0%',
      currentnumbercompliant: currentPeriodCompliant,
      compliantnumberytd: compliantUnits
    });

    this.pieChartDatasets = [{
      data: [compliantUnits, nonCompliantUnits],
      backgroundColor: ['#1f9d61', '#e74c3c'],
      hoverOffset: 6
    }];

    this.barChartData = {
      labels: ['0 months', '1-2 months', '3-6 months', '7+ months'],
      datasets: [{
        data: [
          outstandingGroups['0 months'],
          outstandingGroups['1-2 months'],
          outstandingGroups['3-6 months'],
          outstandingGroups['7+ months']
        ],
        label: 'Units by outstanding period',
        backgroundColor: ['#1f9d61', '#2c7be5', '#f39c12', '#e74c3c'],
        borderRadius: 8
      }]
    };

    this.lineChartData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
      datasets: [{
        data: generatedTrend.map((value) => Number(value.toFixed(1))),
        label: 'Compliance %',
        fill: true,
        tension: 0.35,
        borderColor: '#2c7be5',
        backgroundColor: 'rgba(44, 123, 229, 0.12)',
        borderWidth: 3,
        pointRadius: 4,
        pointHoverRadius: 5
      }]
    };
  }

  viewPropertyCompliance(): void {
    this.action = 'view';
    const propstr = localStorage.getItem('property');

    if (!propstr) {
      this.pageLoading = false;
      return;
    }

    this.property = JSON.parse(propstr);
    const request = { propertyid: this.property.id };

    this.pageLoading = true;

    this.financialService.fetchCompliance(request).subscribe({
      next: (result) => {
        if (!environment.production) {
          console.log('Compliance data: Fetched:: ', result);
        }
        this.compliancedata = result;
      },
      error: (error) => {
        if (!environment.production) {
          console.log('Compliance : Error: ', error);
        }
      }
    });

    this.financialService.fetchComplianceList(request).subscribe({
      next: (result) => {
        if (!environment.production) {
          console.log('Compliance List Data: Fetched:: ', result);
        }
        this.complianceList = Array.isArray(result) ? result : [];
        this.updateComplianceSummaryAndCharts();
        this.pageLoading = false;
        $('#compliance-loading').css('display', 'none');
      },
      error: (error) => {
        if (!environment.production) {
          console.log('Compliance List : Error: ', error);
        }
        this.complianceList = [];
        this.updateComplianceSummaryAndCharts();
        this.pageLoading = false;
        $('#compliance-loading').css('display', 'none');
      }
    });
  }

  goBack(): void {
    this._location.back();
  }

  printScreen() {
    window.print();
  }

  downloadScreen(propertyname: string) {
    this.generatingfile = true;
    const div = document.getElementById('content')!;
    const options = {
      background: 'white',
      scale: 3,
      ignoreElements: (element: Element) => element.classList.contains('d-print-none') ? true : false
    };

    html2canvas(div, options).then((canvas) => {
      const img = canvas.toDataURL('image/PNG');
      const doc = new jsPDF('p', 'mm', 'a4');
      const bufferX = 5;
      const bufferY = 5;
      const imgProps = (<any>doc).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
      return doc;
    }).then((doc) => {
      const filename = 'compliance' + '_' + propertyname + '_' + moment().format('MMMDDYYYY') + '.pdf';
      doc.save(filename);
      this.generatingfile = false;
    });
  }

  toggleSort(): void {
    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
  }

  togglePSort(): void {
    this.psortOrder = this.psortOrder === 'desc' ? 'asc' : 'desc';
  }

  toggleMSort(): void {
    this.msortOrder = this.msortOrder === 'desc' ? 'asc' : 'desc';
  }

  onSelectedProperty(property: any) {
    this.propertyService.setProperty(property);
    this.viewPropertyCompliance();
  }
}

